export const FETCH_FEATURE_FAILURE = 'FETCH_FEATURE_FAILURE';
export const FETCH_FEATURE_LOADING = 'FETCH_FEATURE_LOADING';
export const FETCH_FEATURE_SUCCESS = 'FETCH_FEATURE_SUCCESS';

export const UPDATE_FEATURE_SELECTED = 'UPDATE_FEATURE_SELECTED';
export const FETCH_LEAVE_TYPES_SUCCESS = 'FETCH_LEAVE_TYPES_SUCCESS';
export const FETCH_LEAVE_TYPES_FAILURE = 'FETCH_LEAVE_TYPES_FAILURE';

export const FETCH_HOLIDAYS_LOADING = 'FETCH_HOLIDAYS_LOADING';
export const FETCH_HOLIDAYS_SUCCESS = 'FETCH_HOLIDAYS_SUCCESS';
export const FETCH_HOLIDAYS_FAILURE = 'FETCH_HOLIDAYS_FAILURE';

export const ADD_SETTING_LOADING = 'ADD_SETTING_LOADING';
export const ADD_SETTING_SUCCESS = 'ADD_SETTING_SUCCESS';
export const ADD_SETTING_FAILURE = 'ADD_SETTING_FAILURE';

export const DELETE_SETTING_LOADING = 'DELETE_SETTING_LOADING';
export const DELETE_SETTING_SUCCESS = 'DELETE_SETTING_SUCCESS';
export const DELETE_SETTING_FAILURE = 'DELETE_SETTING_FAILURE';